<template>
  <div>
    <b-button size='sm' @click="downloadFile()" :disabled="isDownloading">
      <div v-if="isDownloading">
         Downloading...   <font-awesome-icon icon="spinner" size="1x" pulse />
      </div>
      <div v-else>
        {{ buttonText }}
      </div>
    </b-button>
  </div>
</template>

<script>
import api from '../../api';
import FileDownloaderHelper from '../../mixins/FileDownloaderHelper';

export default {
  name: 'DownloadFile',
  mixins: [FileDownloaderHelper],
  props: {
    entityId: {
      default: 1,
    },
    urlToDownloadFrom: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'Download File',
    },
    contentType: {
      type: String,
      default: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    },
    defaultFileName: {
      type: String,
      default: 'Property Development Rights Summary and BE Features.xlsx',
    },
  },
  data() {
    return {
      isDownloading: false,
    };
  },
  methods: {
    downloadFile() {
      this.isDownloading = true;
      api.get(this.urlToDownloadFrom, {
        responseType: 'arraybuffer',
      })
        .then((response) => {
          const filename = this.defaultFileName;
          const responseFileName = this.getFileNameFromResponseHeader(response, filename);
          const contentTypeString = this.contentType;
          const blob = new Blob([response.data], { type: contentTypeString });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = responseFileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error('Error downloading file', error);
        })
        .finally(() => {
          this.isDownloading = false;
        });
    },
  },
};
</script>
